export const mainHomeHeroImageXS = require('./sg-salad-xs.jpg');
export const mainHomeHeroImageSM = require('./sg-salad-sm.jpg');
